import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import { Text, H6, Label1 } from '../../atoms/typography';
const ClampedLabel = styled(Label1) `
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const ProductDetails = ({ parentSku, title, color }) => {
    return (_jsxs(Box, { translate: "no", sx: { paddingBottom: '24px', textAlign: 'center' }, children: [_jsx(Text, { color: "text.secondary", children: parentSku }), _jsx(H6, { translate: "yes", children: title }), _jsx(ClampedLabel, { color: "text.secondary", children: color })] }));
};
export default ProductDetails;
//# sourceMappingURL=ProductDetails.js.map